var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SsIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.999,
    viewBox: "0 0 24 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-calendar",
    "data-name": "Icon ionic-md-calendar",
    d: "M20,3V5H10V3H7V5H5.5A2.507,2.507,0,0,0,3,7.5v17A2.507,2.507,0,0,0,5.5,27h19A2.507,2.507,0,0,0,27,24.5V7.5A2.507,2.507,0,0,0,24.5,5H23V3Zm4.5,21.5H5.5V11.25h19Z",
    transform: "translate(-3 -3)",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2962",
    "data-name": "Path 2962",
    d: "M13.453,16.156l1.936,2.127,3.5-5.084",
    fill: "none",
    stroke: "#414042",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsIcon);
export default __webpack_public_path__ + "static/media/SsIcon.addea3fdbd3e2dfa24b8f837b1be157b.svg";
export { ForwardRef as ReactComponent };